module.exports = __webpack_public_path__ + "img/xjip-qrc.f42c3df6.png";